<template>
  <div class="manual-scan-container">
    <!-- Header -->
    <div class="header">
      <img src="/static/img/logo_blk.png" alt="e-MemberS Logo" class="logo" />
      <div class="header-title">
        <span class="brand">e-MemberS</span>
        <div class="subtitle">Qr Scanner for Check in/Out</div>
      </div>
    </div>

    <!-- Info Box -->
    <div class="info-box">
      <div class="info-title">
        <span class="icon-qr">&#x1F4F7;</span>
        <b>Scan Digital Member Card</b>
      </div>
      <ul class="info-list">
        <li>Arahkan kamera ke QR Code pada digital member card</li>
        <li>Sistem akan otomatis memvalidasi tiket sesuai jadwal</li>
      </ul>
    </div>

    <!-- Manual Input Section -->
    <div class="manual-input-section">
      <div class="input-container">
        <div class="input-wrapper">
          <i class="fa fa-keyboard-o input-icon"></i>
          <input 
            id="passCode" 
            type="text" 
            class="passcode-input"
            placeholder="Ketik ID Reservasi Manual"
            v-model="formData.passCode"
            v-on:keyup.enter="onEnterPassCode"
          />
        </div>
        <div class="input-hint">Tekan Enter atau klik tombol untuk submit</div>
      </div>
    </div>

    <!-- QR Code Scanner Section -->
    <div class="scanner-section">
      <div class="scanner-card">
        <div v-if="!isScannerEnabled || cameraError" class="camera-inactive">
          <i class="fa fa-camera camera-icon"></i>
          <div class="camera-title">Kamera Tidak Aktif</div>
          <div class="camera-desc">Klik tombol "Mulai Scan" untuk mengaktifkan kamera</div>
        </div>
        <div v-else>
          <div class="scanner-title">QR Code Scanner</div>
          <div class="scanner-desc">Scan Tiket Qr untuk mencatat kehadiran</div>
          <StreamBarcodeReader 
            v-if="isScannerEnabled && !cameraError"
            @decode="onDecode" 
            @loaded="onLoaded"
            @error="onScanError"
          />
        </div>
      </div>
    </div>
    <div class="btn-scan-qr">
      <button class="scan-btn" @click="toggleScanner">
        <i class="fa fa-play"></i> Mulai Scan
      </button>
    </div>

    <!-- Modal Alert -->
    <div v-if="messageType" class="modal-overlay" @click="closeBanner">
      <div class="modal-alert" :class="{'modal-success': messageType === 'SUCCESS', 'modal-error': messageType === 'ERROR'}" @click.stop>
        <div class="modal-header">
          <div class="modal-icon">
            <i v-if="messageType === 'SUCCESS'" class="fa fa-check-circle"></i>
            <i v-if="messageType === 'ERROR'" class="fa fa-exclamation-circle"></i>
          </div>
          <button class="modal-close" @click="closeBanner">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <h3 class="modal-title">{{ messageType === 'SUCCESS' ? 'Berhasil!' : 'Terjadi Kesalahan' }}</h3>
          <div class="modal-message" v-html="messageText"></div>
        </div>
        <div class="modal-footer">
          <button class="modal-btn" @click="closeBanner">OK</button>
          <button class="modal-btn" @click="toggleScanner">Scan Again</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { StreamBarcodeReader } from 'vue-barcode-reader'
import api from '../../api'
export default {
  name: 'ManualScanCheckInOut',
  components: { StreamBarcodeReader },
  data() {
    return {
      isScannerEnabled: false,
      cameraError: false,
      messageType: '',
      messageText: '',
      formData: {
        passCode: ''
      },
      viewType: '',
      projectId: 0,
      gateId: '',
      passCodeId: '',
      paymentMethodName: '',
      baseAPIUrl: '',
      category: '',
      isTapIn: false,
      isTapInCount: 0
    }
  },
  created() {
    this.gateId = this.$route.params.gateId
    this.projectId = this.$route.params.projectId
    this.baseAPIUrl = this.$route.params.baseAPIUrl
    this.callback = this.$route.params.callback
    this.category = this.$route.params.category || ''
  },
  mounted() {
    document.getElementById('passCode').focus()
  },
  methods: {
    toggleScanner() {
      this.isScannerEnabled = !this.isScannerEnabled
      this.cameraError = false
      this.closeBanner()
    },
    closeBanner() {
      this.messageType = ''
      this.messageText = ''
      this.formData.passCode = ''
      document.getElementById('passCode').value = ''
      document.getElementById('passCode').focus()
    },
    onDecode: async function(text) {
      if (this.category === 'court') {
        const reserve = await this.getDetailReservetion(text)
        if (!reserve) {
          this.messageType = 'ERROR'
          this.messageText = 'Reservation not found'
          return
        }
        // Get passcode using orderId
        const passCodeData = await this.getPasscodeByOrderId(reserve.project_id, reserve.order_id)
        if (passCodeData && passCodeData.length > 0) {
          this.isTapInCount = 0
          for (var i = 0; i < passCodeData.length; i++) {
            this.formData.passCode = `${passCodeData[i].id}|${passCodeData[i].payment_method_name}`
            await this.onTapIn(passCodeData[i])
            this.isTapInCount++
            console.log(`Decode category text from QR code is ${passCodeData[i].id}`)
          }
          console.log(passCodeData.length + '===' + this.isTapInCount)
          if (passCodeData.length === this.isTapInCount) {
            this.isScannerEnabled = false
          }
        } else {
          this.messageType = 'ERROR'
          this.messageText = 'No valid passcode found for this reservation'
        }
      } else {
        // fallback: just set passCode and call onEnterPassCode
        this.formData.passCode = text
        this.onEnterPassCode()
        console.log(`Decode other category text from QR code is ${text}`)
      }
    },
    onLoaded() {
      console.log(`Ready to start scanning barcodes`)
    },
    onScanError() {
      this.cameraError = true
      this.messageType = 'ERROR'
      this.messageText = 'Camera access is not available. Please check your camera permissions and settings.'
    },
    async onEnterPassCode() {
      if (this.category !== 'court') {
        this.messageText = `Category is set to ${this.category}. Please use the appropriate scanner.`
        this.messageType = 'ERROR'
        this.formData.passCode = ''
        return
      }
      // if (this.isTapIn) {
      //  document.getElementById('passCode').value = ''
      //  return
      // }
      let passCode = document.getElementById('passCode').value
      if (passCode === '') {
        return
      }

      this.isTapIn = true
      const reserve = await this.getDetailReservetion(passCode)
      if (!reserve) {
        this.messageType = 'ERROR'
        this.messageText = 'Reservation not found'
        return
      }
      // Get passcode using orderId
      const passCodeData = await this.getPasscodeByOrderId(reserve.project_id, reserve.order_id)
      if (passCodeData && passCodeData.length > 0) {
        this.isTapInCount = 0
        for (var i = 0; i < passCodeData.length; i++) {
          this.formData.passCode = `${passCodeData[i].id}|${passCodeData[i].payment_method_name}`
          await this.onTapIn(passCodeData[i])
          this.isTapInCount++
          console.log(`Decode category text from QR code is ${passCodeData[i].id}`)
        }
        console.log(passCodeData.length + '===' + this.isTapInCount)
        if (passCodeData.length === this.isTapInCount) {
          this.isScannerEnabled = false
          this.isTapIn = false
        }
      } else {
        this.messageType = 'ERROR'
        this.messageText = 'No valid passcode found for this reservation'
        this.isTapIn = false
      }
      this.isTapIn = false
      document.getElementById('passCode').value = ''
      document.getElementById('passCode').focus()
    },
    async onTapIn(passCode) {
      let me = this
      // this.category = this.$route.query.category
      // this.gateId = this.$route.query.gateId
      if (this.category && this.category === '') {
        this.messageText = `Category is set to ${this.category}. Please use the appropriate scanner.`
        this.messageType = 'ERROR'
        return
      }
      this.isTapIn = true
      var reqData = {
        id: '',
        gate_id: this.gateId,
        gate_name: '',
        process_date: '',
        pass_code_id: passCode.id,
        status: '',
        payment_method_name: passCode.payment_method_name,
        project_id: passCode.project_id
      }
      api
        .request('Gate', 'post', '/api/Gate/TapIn', reqData)
        .then(response => {
          if (response.data.entity.status === 'INVALID') {
            this.messageText = response.data.returnMessage.join('<br>')
            this.messageType = 'ERROR'
            this.isTapIn = false
          } else {
            this.messageText = 'TAP-IN done. Please continue click CHECK-IN'
            this.messageType = 'SUCCESS'
            api.request('Gate', 'post', '/api/Gate/CheckIn', reqData)
                .then(response => {
                  if (response.data.returnStatus) {
                    me.viewType = 'ENTER-PASSCODE'
                    this.messageText = response.data.returnMessage.join('<br>')
                    this.messageType = 'SUCCESS'
                  } else {
                    this.messageText = response.data.returnMessage.join('<br>')
                    this.messageType = 'ERROR'
                  }
                  return response.data.returnStatus
                })
                .then(isSuccess => {
                  if (isSuccess) {
                    api.request('Gate', 'post', '/api/Gate/ReleaseQueue', reqData)
                      .then(response => {
                        console.log(response.data.returnMessage.join('<br>'))
                      })
                      .catch(error => {
                        var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
                        console.log(message)
                      })
                    this.isTapIn = false
                  }
                })
                .catch(error => {
                  var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
                  this.messageText = message
                  this.messageType = 'ERROR'
                })
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          this.messageText = message
          this.messageType = 'ERROR'
          this.isTapIn = false
        })
    },
    async getDetailReservetion(reserveId) {
      try {
        const response = await api.request('Reservation', 'get', '/api/Reservation/' + reserveId, null)
        return response.data.entity || null
      } catch (error) {
        console.error('Error getting reservation details:', error)
        return null
      }
    },
    async getPasscodeByOrderId(projectId, orderId) {
      try {
        const url = `/api/Gate/InquiryPassCode?WhereClause=project_id=${projectId} AND order_id='${orderId}'&PageSize=1000&CurrentPageNumber=1&SortDirection=DESC&SortExpression=created_date`
        const response = await api.request('Gate', 'get', url, null)
        return response.data.entity || []
      } catch (error) {
        console.error('Error getting passcode by order ID:', error)
        return []
      }
    }
  }
}
</script>

<style scoped>
.manual-scan-container {
  max-width: 480px;
  margin: 30px auto;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  padding: 0 0 32px 0;
}
.header {
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding: 18px 24px 10px 24px;
}
.logo {
  width: 48px;
  height: 48px;
  margin-right: 16px;
}
.header-title {
  display: flex;
  flex-direction: column;
}
.brand {
  color: #e74c3c;
  font-weight: bold;
  font-size: 28px;
  line-height: 1;
}
.subtitle {
  font-size: 18px;
  color: #222;
  font-weight: 500;
  margin-top: 2px;
}
.info-box {
  background: #fff6ee;
  border: 2px solid #ffb97a;
  border-radius: 12px;
  margin: 24px 0 0 0;
  padding: 18px 20px 12px 20px;
  color: #c05a0a;
  font-size: 18px;
}
.info-title {
  font-size: 20px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.icon-qr {
  font-size: 22px;
  margin-right: 6px;
}
.info-list {
  margin: 0 0 0 18px;
  padding: 0;
  font-size: 16px;
}

/* Manual Input Section */
.manual-input-section {
  display: flex;
  justify-content: center;
  padding: 24px 20px;
}

.input-container {
  width: 100%;
  max-width: 420px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  padding: 8px 8px 8px 16px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.input-wrapper:focus-within {
  border-color: #ff7e5f;
  background: white;
  box-shadow: 0 4px 12px rgba(255, 126, 95, 0.15);
}

.input-icon {
  color: #999;
  font-size: 20px;
  margin-right: 12px;
  transition: color 0.3s;
}

.input-wrapper:focus-within .input-icon {
  color: #ff7e5f;
}

.passcode-input {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 16px;
  padding: 12px 8px;
  outline: none;
  color: #333;
}

.passcode-input::placeholder {
  color: #999;
}

.input-submit-btn {
  background: linear-gradient(90deg, #ff7e5f 0%, #feb47b 100%);
  border: none;
  border-radius: 8px;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 6px rgba(255, 126, 95, 0.3);
}

.input-submit-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 10px rgba(255, 126, 95, 0.4);
}

.input-submit-btn:active {
  transform: scale(0.95);
}

.input-submit-btn i {
  color: white;
  font-size: 18px;
}

.input-hint {
  text-align: center;
  font-size: 13px;
  color: #999;
  margin-top: 10px;
}

.scanner-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
}
.scanner-card {
  background: #232228;
  border-radius: 24px;
  width: 340px;
  height: 440px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.10);
}
.camera-inactive {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.camera-icon {
  font-size: 54px;
  margin-bottom: 18px;
  color: #fff;
}
.camera-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 8px;
}
.camera-desc {
  font-size: 15px;
  color: #ccc;
}
.scanner-title {
  font-size: 26px;
  font-weight: bold;
  color: #232228;
  margin-top: 18px;
  text-align: center;
}
.scanner-desc {
  font-size: 17px;
  color: #888;
  margin-bottom: 18px;
  text-align: center;
}
.scan-btn {
  background: linear-gradient(90deg, #ff7e5f 0%, #feb47b 100%);
  color: #fff;
  font-size: 22px;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  padding: 16px 48px;
  box-shadow: 0 2px 8px rgba(255,126,95,0.10);
  cursor: pointer;
  margin-top: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: background 0.2s;
}
.scan-btn:hover {
  background: linear-gradient(90deg, #feb47b 0%, #ff7e5f 100%);
}
.btn-scan-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 32px;
}

/* Modal Alert Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal-alert {
  background: white;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.3s ease;
  overflow: hidden;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.modal-header {
  position: relative;
  padding: 24px 24px 0 24px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.modal-icon {
  font-size: 64px;
  margin-bottom: 16px;
}

.modal-success .modal-icon {
  color: #6ec89b;
}

.modal-error .modal-icon {
  color: #F44336;
}

.modal-close {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  color: #999;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-body {
  padding: 0 24px 24px 24px;
  text-align: center;
  background-color: #FFFFFF;
}

.modal-title {
  font-size: 24px;
  font-weight: 600;
  margin: 0 0 12px 0;
  color: #333;
}

.modal-message {
  font-size: 16px;
  color: #666;
  line-height: 1.5;
}

.modal-footer {
  padding: 0 24px 24px 24px;
  display: flex;
  justify-content: space-between;
}

.modal-btn {
  background: linear-gradient(90deg, #ff7e5f 0%, #feb47b 100%);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 48px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 8px rgba(255, 126, 95, 0.3);
}

.modal-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(255, 126, 95, 0.4);
}

.modal-btn:active {
  transform: translateY(0);
}

/* Remove old banner styles */
.message-banner-success,
.message-banner-error {
  display: none;
}
</style>



// WEBPACK FOOTER //
// ManualScanCheckInOut.vue?d7f43330